var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 53.3546C10.6407 52.8092 10.8653 52.2745 11.0792 51.7397L10.4375 53.3546Z",
    fill: "#FF3234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 53.3546C10.6407 52.8092 10.8653 52.2745 11.0792 51.7397",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4058 53.3546C10.6197 52.8092 10.8335 52.2637 11.0581 51.729L27.827 74.6793L121.136 76.3583L143.081 50.8842C132.141 25.3458 106.795 7.46472 77.2567 7.46472C47.7187 7.46472 21.8167 25.7522 11.0902 51.7397",
    fill: "#FF3234"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.621 49.9217C146.589 58.8088 148.781 68.6584 148.781 79.0213C148.781 118.548 116.74 150.578 77.2245 150.578C37.7085 150.578 5.66797 118.548 5.66797 79.0213C5.66797 69.9738 7.347 61.322 10.4056 53.3546",
    fill: "#FF3234"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.621 49.9217C146.589 58.8088 148.781 68.6584 148.781 79.0213C148.781 118.548 116.74 150.578 77.2245 150.578C37.7085 150.578 5.66797 118.548 5.66797 79.0213C5.66797 69.9738 7.347 61.322 10.4056 53.3546",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_380_2702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 146,
    height: 145
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 53.3546C10.6407 52.8092 10.8653 52.2745 11.0792 51.7397L10.4375 53.3546Z",
    fill: "#FF3234"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 53.3546C10.6407 52.8092 10.8653 52.2745 11.0792 51.7397",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4058 53.3546C10.6197 52.8092 10.8335 52.2637 11.0581 51.729L27.827 74.6793L121.136 76.3583L143.081 50.8842C132.141 25.3458 106.795 7.46472 77.2567 7.46472C47.7187 7.46472 21.8167 25.7522 11.0902 51.7397",
    fill: "#FF3234"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.621 49.9217C146.589 58.8088 148.781 68.6584 148.781 79.0213C148.781 118.548 116.74 150.578 77.2245 150.578C37.7085 150.578 5.66797 118.548 5.66797 79.0213C5.66797 69.9738 7.347 61.322 10.4056 53.3546",
    fill: "#FF3234"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.621 49.9217C146.589 58.8088 148.781 68.6584 148.781 79.0213C148.781 118.548 116.74 150.578 77.2245 150.578C37.7085 150.578 5.66797 118.548 5.66797 79.0213C5.66797 69.9738 7.347 61.322 10.4056 53.3546",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_380_2702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.119 104.153L137.456 105.479C135.787 108.816 134.119 112.153 132.451 115.489",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.354 103.672L138.119 104.143",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.161 96.0469L141.434 97.512",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.265 160.588C111.265 156.449 110.527 151.594 112.43 147.808C114.003 144.696 117.179 143.498 119.927 141.627C124.601 138.429 129.296 135.263 133.948 132.044C137.434 129.638 140.364 127.617 142.257 123.649L142.332 123.478C144.428 118.783 146.524 114.088 148.62 109.404L152.577 100.539C153.914 97.5441 155.315 95.0202 153.711 91.7798C152.396 89.1169 149.754 88.4859 147.016 89.2666C144.353 90.0366 143.273 93.8224 142.161 96.0576",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9404 160.588C89.9404 152.407 88.7854 143.348 92.2932 135.766C95.416 129.018 101.116 125.531 107.084 121.671C109.105 120.366 111.126 119.061 113.137 117.735C117.436 114.912 124.131 109.426 129.36 112.987C129.36 112.987 136.301 116.955 129.36 121.66L114.484 132.322",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.883 92.3573C142.354 91.9081 140.696 91.8333 139.135 92.1113C137.712 92.368 136.728 92.6674 135.563 93.5551C134.14 94.6352 132.408 97.3516 131.563 98.9558C130.654 100.688 129.83 102.464 128.964 104.217C127.713 106.752 126.451 109.287 125.2 111.821",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.189 99.4049C131.189 99.4049 127.563 97.3088 124.034 99.6936C121.061 101.693 116.291 113.789 115.147 116.366",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.389 35.2276C94.389 35.2276 73.6418 30.7359 62.8725 35.1741C62.8725 35.1741 37.3128 36.2115 34.5322 55.654C34.5322 55.654 41.7831 68.5301 46.3282 69.3215C50.8733 70.1128 49.6007 74.027 49.6007 74.027L54.0924 82.9569L55.8783 102.891L49.6007 100.56L46.5849 101.501L46.9699 115.5L48.9804 117.906L70.3265 119.51L73.6632 115.5H81.299L85.2239 118.163L104.174 117.864L108.688 106.87L111.415 93.8973V82.1013H107.019L103.522 88.0581L100.87 90.4965V82.1013L105.404 71.3962L121.157 55.3545C121.157 55.3545 115.714 37.944 94.4104 35.2383L94.389 35.2276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0923 82.9462C54.0923 82.9462 54.3383 118.152 63.5141 118.152C64.9364 118.152 69.0859 118.152 69.7383 118.152C73.0108 118.184 73.6631 115.66 73.6631 112.335V92.1006",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9906 104.848C54.9906 104.848 50.9588 100.635 50.9481 100.635C49.515 99.1376 47.2371 99.4691 46.5848 101.49C46.1891 102.71 46.3709 108.613 46.3602 110.153C46.3388 112.891 46.2639 116.217 48.9803 117.896C49.9107 118.473 52.3919 118.313 54.0067 118.323C57.0332 118.323 60.0598 118.323 63.0863 118.323",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9669 117.799C92.4857 118.035 91.9723 118.152 91.4376 118.152C90.0152 118.152 85.8658 118.152 85.2134 118.152C81.9409 118.184 81.2886 115.66 81.2886 112.334V92.1006",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.849 82.9462C100.849 82.9462 100.763 94.8598 98.8916 104.827",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.41 106.453C100.41 106.453 94.9774 100.635 94.9667 100.624C93.5336 99.1268 91.2557 99.4584 90.6033 101.48C90.2076 102.699 90.3894 108.602 90.3787 110.142C90.3573 112.88 90.2825 116.206 92.9989 117.885C93.9293 118.462 96.4104 118.302 98.0253 118.313C99.0519 118.313 100.089 118.313 101.116 118.313C101.608 118.313 102.1 118.323 102.592 118.313C104.634 118.248 105.736 116.463 106.495 114.805C108.613 110.142 108.987 104.089 108.484 98.9557C108.035 94.3464 105.843 87.9725 101.308 87.0956",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.164 87.609C104.164 87.609 105.5 86.8604 106.217 84.176C106.944 81.4597 110.837 81.3848 111.639 84.0798C112.676 87.609 112.623 92.4749 109.436 98.8702",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6523 115.489H81.2882",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.492 33.1635C77.492 33.1635 67.3002 32.5646 62.8727 35.1741C62.4664 35.4201 61.0761 35.1848 60.5948 35.2276C58.5415 35.388 56.4988 35.8051 54.5204 36.3932C47.5904 38.468 41.5694 42.8313 36.8745 48.2855C34.1368 51.4724 33.0459 54.8626 36.1152 58.3169L39.7407 62.7123C42.4357 65.9741 48.3176 73.8666 53.0232 68.5728C53.0232 68.5728 58.488 63.7496 60.9905 55.6967",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5898 71.3855C49.5898 71.3855 50.5951 84.8605 65.2786 86.8711",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6212 66.9901C67.2395 66.9901 68.5515 65.6781 68.5515 64.0598C68.5515 62.4414 67.2395 61.1295 65.6212 61.1295C64.0028 61.1295 62.6909 62.4414 62.6909 64.0598C62.6909 65.6781 64.0028 66.9901 65.6212 66.9901Z",
    fill: "#FF3234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4116 71.5245L74.1658 69.2787C73.3209 68.4338 73.9198 66.9901 75.1176 66.9901H79.8445C81.0423 66.9901 81.6412 68.4338 80.7963 69.2787L78.5505 71.5245C77.9623 72.1127 76.9998 72.1127 76.4116 71.5245Z",
    fill: "#FF3234",
    stroke: "#FF3234",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3159 74.4013C70.3159 74.4013 72.8505 79.0855 77.0641 75.9092V72.348",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4917 33.1635C77.4917 33.1635 87.6835 32.5646 92.111 35.1741C92.5174 35.4201 93.9077 35.1848 94.3889 35.2276C96.4423 35.388 98.4849 35.8051 100.463 36.3932C107.393 38.468 113.414 42.8313 118.109 48.2855C120.847 51.4724 121.938 54.8626 118.869 58.3169C117.66 59.782 116.452 61.2471 115.243 62.7123C112.548 65.9741 106.666 73.8666 101.961 68.5728C101.961 68.5728 96.4957 63.7496 93.9932 55.6967",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.383 71.3855C105.383 71.3855 104.378 84.8605 89.6943 86.8711",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3522 66.9901C90.9705 66.9901 92.2824 65.6781 92.2824 64.0598C92.2824 62.4414 90.9705 61.1295 89.3522 61.1295C87.7338 61.1295 86.4219 62.4414 86.4219 64.0598C86.4219 65.6781 87.7338 66.9901 89.3522 66.9901Z",
    fill: "#FF3234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6574 74.4013C84.6574 74.4013 82.1228 79.0855 77.9092 75.9092V72.348",
    stroke: "#FF3234",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0728 77.6738V85.6091",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0403 81.6414H26.105",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5491 73.118C23.0198 73.118 24.2121 71.9257 24.2121 70.455C24.2121 68.9843 23.0198 67.7921 21.5491 67.7921C20.0785 67.7921 18.8862 68.9843 18.8862 70.455C18.8862 71.9257 20.0785 73.118 21.5491 73.118Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.432 80.5399C15.9931 80.5399 16.448 80.0851 16.448 79.524C16.448 78.9629 15.9931 78.508 15.432 78.508C14.8709 78.508 14.416 78.9629 14.416 79.524C14.416 80.0851 14.8709 80.5399 15.432 80.5399Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.688 84.7386L128.524 81.4086L125.194 77.5725L121.358 80.9025L124.688 84.7386Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.177 76.7006L135.83 80.048",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.177 80.048L135.83 76.7006",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.098 69.8561C128.381 69.8561 128.611 69.6263 128.611 69.3428C128.611 69.0593 128.381 68.8295 128.098 68.8295C127.814 68.8295 127.584 69.0593 127.584 69.3428C127.584 69.6263 127.814 69.8561 128.098 69.8561Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1573 160.588C44.1573 156.449 44.8952 151.594 42.9916 147.808C41.4195 144.696 38.2433 143.498 35.4948 141.627C30.8213 138.429 26.1264 135.263 21.4744 132.044C17.988 129.638 15.0577 127.617 13.1648 123.649L13.0899 123.478C10.9938 118.783 8.8977 114.088 6.80158 109.404C5.48617 106.453 4.16006 103.49 2.84464 100.539C1.52922 97.5869 0.106861 95.0202 1.71103 91.7798C3.02644 89.1169 5.66797 88.4859 8.40575 89.2666C11.0687 90.0366 12.1488 93.8224 13.261 96.0576C14.8331 99.2017 16.4052 102.346 17.9773 105.479C19.6456 108.816 21.3139 112.153 22.9823 115.489",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.482 160.588C65.482 152.407 66.637 143.348 63.1292 135.766C60.0065 129.018 54.3063 125.531 48.3388 121.671C46.3176 120.366 44.2963 119.061 42.2858 117.735C37.9866 114.912 31.2919 109.426 26.0623 112.987C26.0623 112.987 19.1216 116.955 26.0623 121.66L40.9383 132.322",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5391 92.3573C13.0684 91.9081 14.726 91.8333 16.2874 92.1113C17.7098 92.368 18.6936 92.6674 19.8593 93.5551C21.2817 94.6352 23.0142 97.3516 23.8591 98.9558C24.7681 100.688 25.5916 102.464 26.4578 104.217C27.7091 106.752 28.971 109.287 30.2223 111.821",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2227 99.4049C24.2227 99.4049 27.8481 97.3088 31.3772 99.6936C34.3503 101.693 39.12 113.789 40.2643 116.366",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9825 47.462C19.7632 48.0074 20.5118 48.6063 21.2283 49.2159C22.4475 50.2105 22.8539 51.8574 21.7524 54.0284C20.6294 56.2742 19.0467 56.948 17.5281 56.5416C13.6887 55.5684 9.69972 53.9535 6.42722 51.7077C5.1332 50.8735 4.63056 48.8843 6.09569 45.9648C7.53944 43.1307 9.41097 42.4249 10.8333 42.9917C11.721 43.3125 12.6086 43.6761 13.4535 44.1146C14.1379 42.4677 15.1753 40.8207 16.3624 39.5481C15.6458 38.9171 14.9507 38.2861 14.2983 37.6017C13.2182 36.5002 13.0685 34.5324 14.9293 32.1796C16.8222 29.8268 18.7472 29.5702 20.0519 30.4043C23.3672 32.5646 26.4686 35.5698 28.9925 38.6284C29.9764 39.8582 30.0833 41.5159 28.6289 43.3232C27.1958 45.1306 25.5596 45.3873 24.1586 44.6707C23.3137 44.2536 22.5117 43.7831 21.6882 43.3125C20.9931 44.7456 20.0306 46.2 19.0039 47.462H18.9825Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5696 36.0082C34.0296 37.3771 32.2543 37.7514 31.0138 36.7354C29.5059 35.3772 27.9659 33.9335 26.4793 32.4469C23.0037 29.1103 21.7203 24.2336 28.9391 18.6511C36.361 13.3574 40.5211 16.0524 42.7563 20.3194C43.7616 22.1696 44.7134 24.0518 45.5582 25.8913C46.2106 27.3457 45.3764 28.9285 43.6439 30.0086C41.12 31.6021 39.3661 30.5647 38.5106 29.1745C37.6657 30.0621 37.4198 30.2439 36.2968 30.8214C37.3877 32.0619 37.9117 33.9763 35.5803 36.0082H35.5696ZM32.126 25.8913C31.5485 26.319 32.0084 26.8858 32.4362 26.5864C33.6553 25.7095 34.7782 25.1106 36.2434 24.7149C36.6818 24.6079 36.7246 23.8058 36.1471 23.9342C34.7889 24.1053 33.3666 24.9608 32.126 25.8806V25.8913Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.948 15.9775C53.5255 17.6993 54.1565 20.0307 54.5201 21.7632C54.8516 23.2925 54.2313 24.7683 52.2421 25.5918C50.2102 26.4474 48.7237 25.8378 47.8574 24.5331C45.633 21.2499 43.6331 17.432 42.4995 13.6354C42.0183 12.181 42.7241 10.4485 45.3656 9.33626C46.8521 8.71598 48.0713 8.6839 48.9696 9.01543C52.5951 10.256 54.9692 12.8761 57.8995 14.8118C58.1883 15.1006 58.7337 14.7476 58.3487 14.4375C57.5145 13.7317 56.8942 13.2825 56.0601 12.705C55.7713 11.3789 55.4826 9.91376 55.3328 8.80154C55.2152 7.26154 56.1777 5.70015 58.9262 5.09057C61.6746 4.50237 63.2146 5.51834 63.7601 6.96209C65.0006 10.7051 65.6102 14.9722 65.7385 18.9185C65.7171 20.4906 64.8937 21.8274 62.7762 22.2872C61.311 22.6081 60.2844 22.2445 59.4609 21.5814C57.6321 20.1163 55.3542 17.4106 52.948 15.9561V15.9775Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2517 17.71C67.5351 14.1808 67.1929 10.9939 67.0111 7.35779C66.9149 5.16543 69.3104 3.63612 71.8236 3.34737C73.5133 3.15487 75.5132 3.02654 77.4917 3.05862C85.1489 3.15487 90.1432 6.74821 88.8919 12.7906C87.6728 18.8757 82.9137 21.0788 77.2457 21.0146C75.695 20.9825 74.1443 20.9397 72.7968 20.9076C70.8611 20.8328 68.7329 19.8168 68.2624 17.6993L68.2517 17.71ZM78.1868 13.1649C78.9996 12.4056 79.2883 11.2933 79.3632 10.2774C79.3846 9.78543 78.3151 9.76404 78.3044 10.0956C78.1868 11.1008 77.8874 11.935 77.1708 12.9189C76.9356 13.2183 77.8018 13.5499 78.1868 13.1649Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1108 18.6083C97.7044 19.5387 97.2552 20.4798 96.8274 21.3996C96.1323 22.8112 94.7206 23.5919 92.6566 23.0251C90.5391 22.4583 89.7584 21.0787 89.8974 19.5173C90.2076 15.5818 91.031 11.4751 92.4641 7.80693C93.2341 5.92471 95.3944 5.72151 97.9396 6.20276C99.4796 6.5236 101.073 6.92999 102.57 7.45401C108.581 9.4111 114.163 13.2397 111.49 17.8918C108.72 22.7257 103.586 20.4905 98.1108 18.619V18.6083ZM99.9395 13.3253C101.02 14.1701 102.196 14.769 103.597 15.2182C104.271 15.4214 104.431 14.7369 103.961 14.5658C102.528 14.0632 101.576 13.5285 100.442 12.7264C100.014 12.4269 99.4048 12.8761 99.9395 13.3146V13.3253Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.966 26.4367C109.618 24.7897 110.495 23.1428 111.532 21.3675C112.57 19.5815 113.554 18.0095 114.719 16.6726C116.43 14.5872 121.382 16.7154 125.296 19.8275C129.467 23.0358 132.943 27.5489 130.515 29.8161C129.542 30.7465 128.804 30.3722 127.243 28.2547C126.729 27.5596 126.045 26.7896 125.435 26.2549C123.671 24.6935 122.28 23.8914 120.965 23.3353C120.334 23.0572 120.152 23.6775 120.847 23.9663C123.478 25.132 126.697 27.9446 127.446 29.6878C128.087 31.1743 127.927 32.3079 126.804 33.3774C125.681 34.4468 124.569 34.5858 123.189 34.0297C121.564 33.3774 118.815 30.8107 117.168 28.7467C116.73 28.2013 116.227 28.5435 116.612 29.0461C117.393 30.0835 118.366 31.1101 119.928 32.5004C120.473 32.9817 121.189 33.5271 121.842 33.9549C123.799 35.2703 124.066 36.0296 123.115 36.9279C120.698 39.1738 117.307 36.4574 114.131 33.9763C111.158 31.5593 108.014 28.8857 108.966 26.4474V26.4367Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.461 37.1525C130.536 34.6928 130.14 32.2972 131.606 30.9176C133.124 29.4953 135.541 30.2653 137.787 32.9068C139.584 35.0136 140.995 36.9707 142.289 38.9919C143.562 40.9918 144.728 43.12 145.925 45.676C147.455 48.9805 147.23 51.8039 145.391 52.5632C143.541 53.3332 141.391 51.7397 139.894 48.8201C139.723 48.4779 139.541 48.1464 139.37 47.8042C139.765 47.355 140.161 46.7454 140.45 46.2535C140.653 45.8578 140.065 45.0985 139.915 45.3872C138.279 48.1143 135.049 50.2425 132.91 51.1622C131.274 51.7611 129.167 51.2478 127.477 48.5635C125.798 45.9647 126.194 43.8044 127.445 42.5853C129.157 40.9811 131.188 39.6229 133.766 38.885C133.338 38.2968 132.9 37.7193 132.45 37.1525H132.461Z",
    fill: "white",
    stroke: "#FF3239",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.92c176dd5cd9187f05bb3ec82fdd2504.svg";
export { ForwardRef as ReactComponent };